import type { SignInToWatchItem } from './index.h'

import { createEvent, createStore, sample } from 'effector'
import { register } from '~/core/repository'
import { model as router } from '~/core/router'
import { aye } from '~/shared/helpers'

export const init = createEvent()

export const resetSignInToWatchItem = createEvent()
export const $signInToWatchItem = createStore<SignInToWatchItem | null>(
  null
).reset(resetSignInToWatchItem)

export const signInToWatch = createEvent()

sample({
  clock: signInToWatch,
  source: $signInToWatchItem,
  filter: (item) => aye(item),
  fn: (item) => `/sign-in/~${item!.redirect}`,
  target: [router.navigateReplace, resetSignInToWatchItem],
})

export const openSignInPage = createEvent<Pick<SignInToWatchItem, 'redirect'>>()

sample({
  clock: openSignInPage,
  filter: ({ redirect }) => aye(redirect),
  fn: ({ redirect }) => `/sign-in/~${redirect}`,
  target: router.navigateReplace,
})

register(openSignInPage, 'siginInToWatchFeature/openSignInPage')
